/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { isNull, omit } from 'lodash';
import { DataMapper } from './data-mapper';
import { HeadersData, HttpDataMapper } from './http-data-mapper';

export interface OptimisticLockingSupport {
  etag?: string;
}

export type WithOptimisticLock<T> = T & OptimisticLockingSupport;

export function projectEtag<E, T extends WithOptimisticLock<E>>({ etag }: T): OptimisticLockingSupport {
  return { etag };
}

export class OptimisticLockingHttpDataMapper<ObjectView extends OptimisticLockingSupport>
  extends HttpDataMapper<ObjectView> {

  constructor(mapper: DataMapper<ObjectView, any>) {
    super(mapper);
  }

  serializeHeaders(headers: HeadersData, obj: ObjectView, json: any): any {
    // invariant(obj.etag, "Entity does not have etag field set");
    if (obj.etag) {
      headers.set('If-Match', String(obj.etag));
    }
    return omit(json, 'etag');
  }

  deserializeHeaders(headers: HeadersData, obj: ObjectView): ObjectView {
    const etagHeader = headers.get('ETag');
    // invariant(etagHeader, 'ETag header is not provided');
    obj.etag = isNull(etagHeader) ? void 0 : etagHeader;

    return obj;
  }
}
